import { IProtocol } from '@/pages/Equipment/equipment.types.ts'
import { useRecoilValue } from 'recoil'
import { IOption } from '@/types/global.ts'
import { useMemo } from 'react'
import DropdownInput from '@/shared/Inputs/DropdownInput'
import protocolsAtom from '@/pages/Equipment/atoms/protocols.atom.ts'

interface IProps {
  value: IProtocol['id']
  name: string
  onChange: (val: IProtocol['id'], name: string) => void
  placeholder?: string
}

const ProtocolDropdown = (props: IProps) => {
  const protocols = useRecoilValue(protocolsAtom).items

  const options: IOption<IProtocol['id']>[] = useMemo(() => {
    return protocols.map((p) => ({ title: p.nameRu, value: p.id }))
  }, [protocols])

  return (
    <DropdownInput
      options={options as any}
      selectedOption={props.value as any}
      title={props.placeholder || 'Выберите из списка'}
      onSelect={props.onChange}
      name={props.name}
    />
  )
}

export default ProtocolDropdown
